<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div class="row mt-0">
      <div class="col-sm-12 p-0 custom-form-main-label">
        {{ usercantwork }}
      </div>
    </div>

    <div class="row">
      <div class="col-12 p-0">
        <form id="createShiftForm" name="createShiftForm" class="login-formx form-validate" action="index.html" onsubmit="return false">

          <div class="row mt-3" v-show="interstedusers.length>0">
            <div class="col-lg-12 custom-form-label">
              {{$t('intersted_users')}}
            </div>
          </div>
          <div class="form-group row mt-1" v-show="interstedusers.length>0">
            <div class="col-lg-12">
              <select required class="form-control" v-bind:id="'select_intersted_user_' +  getId()" v-on:change="onChangeIntersted" v-select>
                <option value="" style="">{{$t('select_user')}}</option>
                <option v-for="user in interstedusers" v-bind:value="user.Username">
                  {{ user.Name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('choose_other')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <user-selector required="false" ref="userSelectorRef" @event-change-member="onChangeMember"></user-selector>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12">
              <button :disabled="memberId===''" @click="assignUserToSchedule" type="submit" class="btn skin primary-button pull-right">{{$t('ok')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  var interstedusers = [];
  var usercantwork = "";
  var id = -1;
  import UserSelector from '../user/user-selector.vue'
  export default {
    name: "assign-schedule",
    components: {
      UserSelector
    },
    props: {
      id: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        memberId: '',
        usercantwork: '',
        interstedusers: [],
      };
    },
    methods: {
      onChangeIntersted() {
        this.memberId = $('#select_intersted_user_' + this.getId()).val();
      },
      onChangeMember(memberId) {
        this.memberId = memberId;
      },
      clearFields() {
        this.memberId = '';
        this.usercantwork = '';
        this.interstedusers = [];
        this.id = -1;
        this.$refs.userSelectorRef.selectUser("");
        $("#select_intersted_user_" + this.getId()).val('');
        $("#select_intersted_user_" + this.getId()).trigger('change');
      },
      getId() {
        return this._uid;
      },
      async assignUserToSchedule() {
        var request = {
          id: this.id, username: this.memberId
        };
        try {
          var response = await this.$http.post(
            '/api/task/AssignUserToSchedule',
            request
          ).then(async response => {
            this.clearFields();
            vm.$root.$emit('doAssignSchedule');
          });

        } catch (err) {
          alert(err);
        }
      },

      async getUserShiftDetail(id) {
        try {
          this.$http.get('/api/task/GetAssignUserScheduleDetail?id=' + id).then(async response => {
            var data = response.data;
            this.usercantwork = data.assignedUser;
            this.interstedusers = data.interstedUsers;
            $('#select_intersted_user_' + this.getId()).select2();
            this.$forceUpdate();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      id: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getUserShiftDetail(newVal);
        } 
      }
    },
    mounted() {
      $('#select_intersted_user_' + this.getId()).select2();
      $("#select_intersted_user_" + this.getId()).change(this.onChangeIntersted);
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/calander/assign-schedule.vue